// extracted by mini-css-extract-plugin
export default {"input":"input___3TVqi","label":"label___2XNvK","isInvalid":"isInvalid___BHgk8"};